import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TooltipModule } from "primeng/tooltip";
import {
  DrProfile,
  DrProfilePref,
  Order,
} from "src/app/shared/models/order.model";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "order-profile-pref",
  templateUrl: "./order-profile-pref.component.html",
  styleUrls: ["./order-profile-pref.component.scss"],
  standalone: true,
  imports: [CommonModule, TooltipModule],
})
export class OrderProfilePrefComponent {
  @Input() order: Order;

  get profile(): DrProfile {
    return this.order.drProfile;
  }

  get data(): DrProfilePref[] {
    return this.order.drProfile?.pref ?? [];
  }

  constructor(private authService: AuthService) {}

  getIcon(key: string) {
    return this.authService.assetsUrl + "/assets/rx_icons/" + key;
  }
}
